<div class="claims-wrapper">
  <div class="claims-header" (click)="goBack()">
    <img src="../../../../assets/images/arrow-right.png" alt="">
    Add Nominee Details
  </div>
  <div class="claims-body">
    <div class="top">Please provide the required information to add a nominee.</div>
    <div class="bottom">
      <form *ngIf="currentPolicy?.nomineeEnroll && !isNomineeAvailable" [formGroup]="nomineeDetailForm"
        (submit)="onSubmit($event)">
        <div class="col-sm-12">
          <div >
            <label class="label">Name (as per Gov Id Proof)<sup>*</sup></label>
            <input type="text" class="form-control input" formControlName="name" placeholder="Please enter the name"
              maxlength="50" />
            <span class="error-msg small" *ngIf="
                                      nomineeDetailForm.get('name').dirty && nomineeDetailForm.get('name').status === 'INVALID'
                                      ">Max length 50 characters<i class="fa fa-exclamation-triangle"
                aria-hidden="true"></i>
            </span>
          </div>
        </div>
        <div class="col-sm-12">
          <div >
            <labe class="label"l>Email</labe>
            <input type="text" class="form-control input" formControlName="email" placeholder="Please enter the email id"
              maxlength="50" />
            <span class="error-msg small" *ngIf="
                                    nomineeDetailForm.get('email').dirty && nomineeDetailForm.get('email').status === 'INVALID'
                                    ">Please enter valid email address<i class="fa fa-exclamation-triangle"
                aria-hidden="true"></i>
            </span>
          </div>
        </div>
        <div class="col-sm-12">
          <div >
            <label class="label">Relationship<sup>*</sup></label>
            <select class="form-control input" formControlName="relationship">
              <option value="" disabled selected>--Select a Relationship--</option>
              <option value="Spouse">Spouse</option>
              <option value="Son">Son</option>
              <option value="Daughter">Daughter</option>
              <option value="Mother">Mother</option>
              <option value="Father">Father</option>
            </select>
          </div>
        </div>
        <div class="col-sm-12">
          <div >
            <label class="label">Nominee Percentage Share<sup>*</sup></label>
            <input type="text" class="form-control input" value="100%" disabled />
          </div>
        </div>
        <div class="col-sm-12">
          <div >
            <label class="label">Gender<sup>*</sup></label>
            <select class="form-control input" formControlName="gender">
              <option value="" disabled selected>--Select a Gender--</option>
              <option value="Female">Female</option>
              <option value="Male">Male</option>
            </select>
          </div>
        </div>
        <div class="col-sm-12">
          <div >
            <label class="label">Employee Id<sup>*</sup></label>
            <input type="text" class="form-control input" formControlName="employeeId"
              placeholder="Please enter the employee id" maxlength="20" [(ngModel)]="employeeId"
              [attr.disabled]="!isHrView ? true : null" />
          </div>
        </div>
        <div class="col-sm-12">
          <div >
            <label class="label">Date of Birth<sup>*</sup></label>
            <input class="form-control input" formControlName="dob" placeholder="Please select date of birth" type="text"
              readonly required bsDatepicker [minDate]="minDate" [maxDate]="maxDate" [bsConfig]="{
                                    isAnimated: true,
                                    dateInputFormat: 'DD MMMM YYYY',
                                    adaptivePosition: true,
                                    containerClass: 'theme-dark-blue',
                                    showWeekNumbers: false
                                  }" />
          </div>
        </div>
        <div class="col-sm-12">
          <div >
            <label class="label">Mobile No<sup>*</sup></label>
            <input type="tel" inputmode="numeric" pattern="[0-9]*" class="form-control input" formControlName="mobileno"
              placeholder="Please enter 10 digits mobile number" maxlength="10" />
            <span class="error-msg small" *ngIf="
                                    nomineeDetailForm.get('mobileno').dirty && nomineeDetailForm.get('mobileno').status === 'INVALID'
                                    ">Please enter valid Mobile Number<i class="fa fa-exclamation-triangle"
                aria-hidden="true"></i>
            </span>
          </div>
        </div>
        <div class="col-sm-12">
          <div >
            <label class="label">PAN</label>
            <input type="text" class="form-control input" formControlName="pan"
              placeholder="Please enter 10 characters PAN number" maxlength="10" />
            <span class="error-msg small" *ngIf="
                                    nomineeDetailForm.get('pan').dirty && nomineeDetailForm.get('pan').status === 'INVALID'
                                    ">Please enter valid PAN (All Capitals)<i class="fa fa-exclamation-triangle"
                aria-hidden="true"></i>
            </span>
          </div>
        </div>
        <!-- <div class="col-12 text-center">
          <span *ngIf="isNomineeDataSubmitting" class="spinner-border spinner-border-sm" role="status"></span>
          <input class="btn btn-primary w-100 input" [disabled]="!nomineeDetailForm.valid || isNomineeDataSubmitting"
            type="submit" value="Submit Details">
        </div> -->
      </form>
    </div>

  </div>

</div>

<div class="start-tarack-claim-wrapper" (click)="onSubmit($event)">
  <button class="button-text" [disabled]="!nomineeDetailForm.valid || isNomineeDataSubmitting" >Submit</button>
</div>